<script>
import { get } from 'lodash'
import { routeStartsWith } from '@/helpers/routes'

export default {
  name: 'patient-mobile',
  data: () => {
    return {
      mobileMenuOn: false
    }
  },
  computed: {
    routeIsPatientLoadingPage () {
      if (get(this.$route, 'path', null) === '/') {
        this.pathIndex = true
        return this.$router.push({name: 'patient.loading-page.index'})
      }
      this.pathIndex = true
      return routeStartsWith(this.$route, 'patient.loading-page.')
    },
    routeIsProfessionalLoadingPage () {
      this.pathIndex = false
      return routeStartsWith(this.$route, 'professional.loading-page.')
    },
    isIndex () {
      if (get(this.$route, 'path', null) === '/') {
        console.log('vindo pelo barra')
      }
    }
  }
}
</script>

<template lang="pug">
    div
      #menu-mobile-icon.menu-mobile-off(:class="{'menu-mobile-on': mobileMenuOn}", @click.prevent='mobileMenuOn = !mobileMenuOn')
        .first-line
        .second-line
        .third-line

      #menu-mobile.menu-mobile-off(:class="{'menu-mobile-on': mobileMenuOn}")
        ul
          a(href='', v-scroll-to="'#apresentacao'", @click.prevent="mobileMenuOn = false")
            li.apresentacao Apresentação
          a(href='', v-scroll-to="'#beneficios'", @click.prevent="mobileMenuOn = false", v-if='routeIsPatientLoadingPage || !routeIsProfessionalLoadingPage')
            li.beneficios Benefícios
          a(href='', v-scroll-to="'#contato'", @click.prevent="mobileMenuOn = false")
            li.contato Contato
          .line
          a(href='http://app-v1.medibook.com.br/terms/term', target="_blank")
            li Termos de Uso
          a(href='http://app-v1.medibook.com.br/terms/policy', target="_blank")
            li Políticas de Privacidade


      #login-mobile(v-if='routeIsPatientLoadingPage || !routeIsProfessionalLoadingPage')
        .container
          .col-xs-6
            a.button.mb-cursor-pointer(href='http://app-v1.medibook.com.br/app/auth/login')
              | Entrar
              span.icon 

          .col-xs-6
            a.button(href="https://app-v1.medibook.com.br/app/register/patient")
              | Cadastro
              span.icon 

      a#login-mobile(v-if='routeIsProfessionalLoadingPage')
        .container
          .col-xs-6
            a.button(href='http://app-v1.medibook.com.br/app/auth/professional/login')
              | Entrar
              span.icon 
          .col-xs-6
            a.button(href='https://app-v1.medibook.com.br/app/register/professional')
              | Cadastro
              span.icon 
</template>
<style scoped>
  .mb-corsro-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/layout/headers/mobile/patient.vue